'use client';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useOnboarding } from '@/lib/onboarding-context';
import { useTour } from '@/lib/tour-context';
import { logger } from '@/lib/logger';
import { RotateCcw } from 'lucide-react';
import { useRouter, usePathname } from 'next/navigation';
import { isHelpSystemEnabled } from '@/lib/feature-flags';

/**
 * Client component for resetting onboarding progress
 * Must be used within OnboardingProvider and TourProvider
 * Only shown on home page since that's where the getting started checklist is displayed
 */
export function UserMenuResetOnboarding() {
  // Hooks must be called unconditionally (cannot be in try-catch)
  const { resetChecklist } = useOnboarding();
  const { resetAllTours } = useTour();
  const router = useRouter();
  const pathname = usePathname();
  const helpSystemEnabled = isHelpSystemEnabled();

  const handleReset = () => {
    try {
      // Reset onboarding checklist
      resetChecklist();
      
      // Reset all completed tours
      resetAllTours();
      
      logger.info('Onboarding progress reset from user menu');
      
      // Navigate to home page to show the reset checklist
      router.push('/');
    } catch (error) {
      logger.error('Error resetting onboarding progress', { error });
    }
  };

  // Don't render if help system is disabled
  if (!helpSystemEnabled) {
    return null;
  }

  // Only show on home page since that's where the getting started checklist is displayed
  if (pathname !== '/') {
    return null;
  }

  return (
    <DropdownMenuItem onClick={handleReset} className="cursor-pointer">
      <RotateCcw className="mr-2 h-4 w-4" />
      Reset Getting Started Progress
    </DropdownMenuItem>
  );
}

